export const formatNaurPercentage = (value: ?number | string): string => {
  if (value === null || value === undefined || value === '') {
    return 'Not Provided';
  }

  const numValue = Number(value);

  // Handle NaN explicitly to avoid displaying "NaN%"
  if (isNaN(numValue)) {
    return 'Not Provided';
  }

  return `${numValue.toFixed(2)}%`;
};

/**
 * Validates a single applicable fraction value
 * @param {?number|string} value - The value to validate
 * @returns {boolean} - True if valid or null, false if invalid
 */
export const validateApplicableFractionValue = (
  value: ?number | string,
): boolean => {
  const strValue =
    value !== null && value !== '' && value !== undefined
      ? String(value)
      : null;

  if (strValue === null) {
    return true;
  }

  const numValue = Number(strValue);

  // Check if valid number within range (0-100)
  if (isNaN(numValue) || numValue < 0 || numValue > 100) {
    return false;
  }

  // Reject more than 2 decimal places
  const decimalIndex = strValue.indexOf('.');
  if (decimalIndex !== -1 && strValue.length - decimalIndex - 1 > 2) {
    return false;
  }

  return true;
};
